import { isNumber } from '../isNumber/isNumber';
import { isString } from '../isString/isString';
import { isSymbol } from '../isSymbol/isSymbol';
/**
 * Checks if passed value is any numeric value, e.g. 1 or '1'.
 *
 * @param {unknown} value Value to check.
 * @returns {boolean} Returns `true` if `value` can be correctly converted to number, else `false`.
 */
export function isNumeric(value) {
    // Symbol is not converted to number or string, detect it earlier
    if (isSymbol(value)) {
        return false;
    }
    const isNumericString = isString(value) && value.length > 0 && isNumber(+value);
    const isNumericValue = isNumber(value) && isFinite(value);
    const isConvertableToNumber = !isNaN(+value);
    return (isNumericString || isNumericValue) && isConvertableToNumber;
}
